import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { FaqData } from '../models/faq-data.model';

@Injectable()
export class FaqService {
  constructor(private readonly http: HttpClient) {}

  public getFaqs(packageGuid: string): Observable<FaqData> {
    return this.http.get<FaqData>(`faqs/${packageGuid}`);
  }
}
